import * as api from 'requests'
import { SET_HOME_TITLES } from './HomeReducer'

export const getHomeStructure = () => (dispatch) => {
  api.GET_HOME_PAGE_STRUCTURE(({ MERGED, RAW }) => {
    const { foldLinks, categories } = JSON.parse(MERGED.VALUE)
    const { foldLinks: rawFoldLinks, categories: rawCategories } = JSON.parse(RAW.VALUE)

    dispatch(
      setHomeStructure({
        foldLinks,
        categories,
        appSettingId: MERGED.APP_SETTING_ID,
        rawStructure: { foldLinks: rawFoldLinks, categories: rawCategories },
      })
    )
  })
}

export const getHomeTitles = () => (dispatch) => {
  api.GET_APP_SETTING_BY_NAME(
    'HOME_PAGE_TITLES',
    (res) => {
      const data = JSON.parse(res.VALUE)
      dispatch({
        type: SET_HOME_TITLES,
        bannerTitle: data.bannerTitle,
        bannerSubtitle: data.bannerSubtitle,
        bannerButtonUrl: data.bannerButtonUrl,
        bannerButtonText: data.bannerButtonText,
        mainTitle: data.mainTitle,
        mainSubcontent: data.mainSubcontent,
      })
    },
    (err) => {
      console.error(err)
    }
  )
}

export const setHomeStructure = ({ foldLinks, categories, appSettingId, rawStructure }) => ({
  type: '@@h/SET_HOME_STRUCTURE',
  foldLinks,
  categories,
  appSettingId,
  rawStructure,
})

export const updateAndPushCategories = (categories) => (dispatch, getState) => {
  const state = getState().home
  api.UPDATE_APP_SETTING_BY_ID(
    state.appSettingId,
    {
      NAME: 'HOME_PAGE_LINKS',
      VALUE: JSON.stringify({
        categories: categories,
        foldLinks: state.foldLinks,
      }),
      CATEGORY: 'ADMIN',
      DESCR: '',
    },
    () => {
      dispatch(getHomeStructure())
    },
    (e) => {
      console.error(e)
    }
  )
}

export const updateCategories = (categories) => ({
  type: '@@h/UPDATE_CATEGORIES',
  categories,
})

export const getSystemMessage = () => (dispatch) => {
  api.GET_APP_SETTING_BY_NAME('HOME_PAGE_MESSAGE', (setting) => {
    dispatch(
      populateSystemMessage({
        systemMessage: setting.VALUE,
        messageAppSettingId: setting.APP_SETTING_ID,
      })
    )
  })
}

export const populateSystemMessage = ({ systemMessage, messageAppSettingId }) => ({
  type: '@@h/POPULATE_SYSTEM_MESSAGE',
  systemMessage,
  messageAppSettingId,
})

export const updateAndPushSystemMessage = (message) => (dispatch, getState) => {
  dispatch(updateMessage(message))
  const state = getState().home
  api.UPDATE_APP_SETTING_BY_ID(
    state.messageAppSettingId,
    {
      NAME: 'HOME_PAGE_MESSAGE',
      VALUE: message,
      CATEGORY: 'ADMIN',
      DESCR: '',
    },
    (err) => console.error(err)
  )
}

export const updateMessage = (message) => ({
  type: '@@h/UPDATE_SYSTEM_MESSAGE',
  message,
})

export const updateFoldLinks = (foldLinks) => ({
  type: '@@h/UPDATE_FOLD_LINKS',
  foldLinks,
})

export const updateAndPushFoldLinks = (foldLinks) => (dispatch, getState) => {
  dispatch(updateFoldLinks(foldLinks))
  const state = getState().home
  api.UPDATE_APP_SETTING_BY_ID(
    state.appSettingId,
    {
      NAME: 'HOME_PAGE_LINKS',
      VALUE: JSON.stringify({
        categories: state.categories,
        foldLinks: foldLinks,
      }),
      CATEGORY: 'ADMIN',
      DESCR: '',
    },
    (err) => console.error(err)
  )
}

export const updateAndPushTitles = (titles) => (dispatch) => {
  dispatch({
    type: SET_HOME_TITLES,
    bannerTitle: titles.bannerTitle,
    bannerSubtitle: titles.bannerSubtitle,
    bannerButtonUrl: titles.bannerButtonUrl,
    bannerButtonText: titles.bannerButtonText,
    mainTitle: titles.mainTitle,
    mainSubcontent: titles.mainSubcontent,
  })
  api.UPDATE_APP_SETTING_BY_ID(
    1060,
    {
      NAME: 'HOME_PAGE_TITLES',
      VALUE: JSON.stringify({
        bannerTitle: titles.bannerTitle,
        bannerSubtitle: titles.bannerSubtitle,
        bannerButtonUrl: titles.bannerButtonUrl,
        bannerButtonText: titles.bannerButtonText,
        mainTitle: titles.mainTitle,
        mainSubcontent: titles.mainSubcontent,
      }),
      CATEGORY: 'ADMIN',
      DESCR: '',
    },
    () => {},
    (err) => console.error(err)
  )
}
